import { Button, ConfigProvider } from 'antd';
import colorTokens from '../../../constants/design_system/colors';

export type CustomSecondaryButtonProps = {
  children: React.ReactNode;
  type: 'delete' | 'default';
  onClick: () => void;
};

export const CustomSecondaryButton = (props: CustomSecondaryButtonProps) => {
  let color = colorTokens.brand['taskonio-green'];
  let colorBorder = colorTokens.brand['taskonio-green'];
  switch (props.type) {
    case 'delete':
      color = colorTokens.red[600];
      colorBorder = colorTokens.red[600];
      break;
    case 'default':
      color = colorTokens.neutral[900];
      colorBorder = colorTokens.neutral[300];
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            colorPrimary: color,
            colorText: color,
            colorTextBase: color,
            colorBorder: colorBorder,
          },
        },
      }}
    >
      <Button type={'default'} onClick={props.onClick} className="text-sm font-medium leading-none">
        {props.children}
      </Button>
    </ConfigProvider>
  );
};
